<template>
  <with-actions>
    <sweet-modal ref="add_modal">
      <div class="form-group">
        <label>{{ 'name' | t }}</label>
        <input class="form-control" v-model="new_term.name" />
      </div>
      <div class="form-group">
        <label>{{ 'external_reference' | t }}</label>
        <input class="form-control" v-model="new_term.external_reference" />
      </div>
      <div class="form-group">
        <label>{{ 'days' | t }}</label>
        <input class="form-control" type="number" min="1" v-model="new_term.days" />
      </div>
      <div class="form-group">
        <label>{{ 'invoicing_type' | t }}</label>
        <select class="form-control" v-model="new_term.invoicing_type">
          <option value="net">Net</option>
          <option value="invoice_month">Invoice month</option>
        </select>
      </div>
      <div class="form-group text-right">
        <button class="btn btn-primary" @click="spin($event, save)">{{ 'save' | t }}</button>
      </div>
    </sweet-modal>
    <div class="form-inline ml-auto" slot="context-actions">
      <button class="btn btn-primary" @click="$refs.add_modal.open()">{{ 'add_payment_term' | t }}</button>
    </div>
    <lazy-table model="payment_terms" v-model="payment_terms">
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'name' | t }}</th>
            <th>{{ 'external_reference' | t }}</th>
            <th>{{ 'days' | t }}</th>
            <th>{{ 'invoicing_type' | t }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(term, idx) in payment_terms">
            <td>{{ term.name }}</td>
            <td>{{ term.external_reference }}</td>
            <td>{{ term.days }}</td>
            <td>{{ term.invoicing_type }}</td>
            <td class="text-right">
              <button class="btn btn-sm btn-outline-danger" @click="spin($event, destroy, term, idx)">
                {{ 'delete' | t }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </lazy-table>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import Alerts, { handle } from '@/utils/alerts';

export default {
  data: function () {
    return {
      payment_terms: [],
      new_term: {
        name: '',
        invoicing_type: 'net',
        days: 14,
        external_reference: ''
      }
    };
  },
  async mounted() {},
  methods: {
    destroy: handle(async function (term, idx) {
      await Api.destroy('payment_terms', term.id);
      this.payment_terms.splice(idx, 1);
    }),
    save: handle(async function () {
      let { data } = await Api.create('payment_terms', {
        name: this.new_term.name,
        days: this.new_term.days,
        invoicing_type: this.new_term.invoicing_type,
        external_reference: this.new_term.external_reference
      });

      this.payment_terms.push(data);
      this.$refs.add_modal.close();
    })
  }
};
</script>
